import React, { Component } from 'react';
import _without from 'lodash/without';
import BaseFilter from '../BaseFilter/BaseFilter';
import { Checkbox } from 'wix-style-react';
import s from './servicesFilter.scss';
import { translate } from 'react-i18next';

class ServicesFilter extends Component {
  render() {
    const {
      categories,
      filterTitle,
      applyButtonText,
      clearButtonText,
      currentServices,
      currentCategories,
      onApply,
      onClear,
      t,
    } = this.props;

    return (
      <BaseFilter
        filterDataHook="explore-service-filter"
        applyButtonDataHook="explore-service-filter-apply-button"
        clearButtonDataHook="explore-service-filter-clear-button"
        applyButtonText={applyButtonText}
        clearButtonText={clearButtonText}
        filterTitle={filterTitle}
        onApply={() =>
          onApply({
            categoryIds: currentCategories,
            serviceIds: currentServices,
          })
        }
        onClear={onClear}
        isClearDisabled={
          currentCategories.length === 0 && currentServices.length === 0
        }
      >
        <div className={s.root}>
          {Object.keys(categories).map(categoryDisplayName => (
            <div className={s.categoryRoot} key={categoryDisplayName}>
              <div className={s.category}>
                <Checkbox
                  dataHook={`option-${categoryDisplayName}`}
                  checked={currentCategories.includes(categoryDisplayName)}
                  onChange={() =>
                    this.toggleCategorySelected(categories, categoryDisplayName)
                  }
                >
                  {t(
                    `client-exploreexperts-services-dropdown-${categoryDisplayName}`,
                  )}
                </Checkbox>
              </div>
              <div className={s.servicesRoot}>
                {categories[categoryDisplayName].map(serviceDisplayName => (
                  <div className={s.service} key={serviceDisplayName}>
                    <Checkbox
                      dataHook={`option-${serviceDisplayName}`}
                      checked={currentServices.includes(serviceDisplayName)}
                      onChange={() =>
                        this.toggleServiceSelected(
                          serviceDisplayName,
                          categoryDisplayName,
                        )
                      }
                    >
                      {t(
                        `client-exploreexperts-services-dropdown-${serviceDisplayName}`,
                      )}
                    </Checkbox>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </BaseFilter>
    );
  }

  toggleCategorySelected(categories, categoryKey) {
    const { currentCategories, currentServices, onChange } = this.props;
    const newCategories = _without(currentCategories, categoryKey);
    if (newCategories.length === currentCategories.length) {
      newCategories.push(categoryKey);
    }
    const servicesForCategory = categories[categoryKey];
    const newServices = _without(currentServices, ...servicesForCategory);
    onChange({
      categoryIds: newCategories,
      serviceIds: newServices,
    });
  }

  toggleServiceSelected(serviceKey, categoryDisplayName) {
    const { currentCategories, currentServices, onChange } = this.props;

    const newServices = _without(currentServices, serviceKey);
    if (newServices.length === currentServices.length) {
      newServices.push(serviceKey);
    }
    const newCategories = _without(currentCategories, categoryDisplayName);
    onChange({ serviceIds: newServices, categoryIds: newCategories });
  }
}

export default translate()(ServicesFilter);
